<template>
    <div class="wv-breadcrumb wv-breadcrumb-lg">
        <div class="container">
            <ol itemscope itemtype="https://schema.org/BreadcrumbList">
                <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                    <a :rel="this.brand" :title="this.brand" itemprop="item" v-bind:href="this.brandUri">{{ this.brand }}</a>
                    <meta itemprop="name" :content="this.brand"/>
                    <meta itemprop="position" content="1"/>
                </li>
                <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                    {{ this.title }}
                    <meta itemprop="name" :content="this.title"/>
                    <meta itemprop="position" content="2"/>
                </li>
            </ol>
        </div>
    </div>
</template>

<script>

export default {
    name: "breadcrumb",
    props: ["title"],
    data() {
        return {
            brand: "Wordvice",
            brandUri: "https://wordvice.com",
        }
    },
    created() {
        switch(this.$i18n.locale){
            case "ko":
                this.brand = "에세이리뷰"
                this.brandUri = "https://essayreview.co.kr"
                break
            case "ja":
                this.brand = "ワードバイス"
                this.brandUri = "https://wordvice.jp"
                break
            case "zh":
                this.brand = "Wordvice"
                this.brandUri = "https://wordvice.cn"
                break
            case "zh_TW":
                this.brand = "Wordvice"
                this.brandUri = "https://wordvice.com.tw"
                break
            default:
                this.brand = "Wordvice"
                break;
        }
    },
    methods: {
    }
}
</script>

<style scoped>
    /* Breadcrumb */
    .wv-breadcrumb a {
        color: #ffffff;
    }
    .wv-breadcrumb {
        margin-bottom: 2.5em;
        padding: 1.06em 0;
        background: #2659a8;
    }
    .wv-breadcrumb ol {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding: 0 0;
        list-style: none;
    }
    .wv-breadcrumb li {
        position: relative;
        color: #fff;
    }
    .wv-breadcrumb li+ li {
        padding-left: .285em;
    }

    .wv-breadcrumb li+ li:before {
        content: "";
        float: left;
        margin-right: .285rem;
        width: 12px;
        height: 100%;
        background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cg%3E%3Cpath fill='%23fff' d='M0 0H12V12H0z' transform='translate(-88 -988) translate(88 988)'/%3E%3Cpath d='M13.885 17.607l4.186-4.194-4.186-4.195.593-.593 4.788 4.788-4.788 4.787z' transform='translate(-88 -988) translate(77.425 980.587)'/%3E%3C/g%3E%3C/svg%3E") no-repeat center center;
    }

    .wv-breadcrumb h4 {
        display: inline-block;
        margin: 0;
        color: #fff;
        font-weight: 700;
    }

    .wv-breadcrumb svg {
        float: left;
        margin-top: 4px;
    }

    .wv-breadcrumb-lg li {
        font-weight: 700;
        white-space: nowrap;
        align-items: center;
    }
    .wv-breadcrumb-lg li+ li:before {
        width: 24px;
        background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg%3E%3Cpath fill='none' d='M0 0H24V24H0z' transform='rotate(-90 12 12)'/%3E%3Cpath fill='%23fff' d='M10.307 11.76L14.56 16l4.253-4.244 1.307 1.307-5.56 5.56L9 13.067z' transform='rotate(-90 12 12) translate(-3.001 -2.76)'/%3E%3C/g%3E%3C/svg%3E") no-repeat center center;
    }
</style>


// WEBPACK FOOTER //
// src/components/generator/Breadcrumb.vue